import React, { lazy, Suspense } from "react"
const CaldwellExecutive = lazy(() => import("renderOverrides/caldwellExecutive"))
//? The purpose of this file is to override certain reports and/or components.  This can be used in the render method to render a custom component instead of a the default Pipsy component.  All props will be passed-through to the end custom component.  See the Executive report and what we did for Caldwell.
const RenderOverride = (props) => {
	let el = ''
	if(props.name == 'CaldwellExecutive') {
		el = <CaldwellExecutive {...props} />
	}
	return (
		<Suspense fallback={<div>Loading...</div>}>
			{el}
		</Suspense>
	)
}

export default RenderOverride
